import { render, staticRenderFns } from "./atualizacao-cadastral.vue?vue&type=template&id=09d9f20f"
import script from "./atualizacao-cadastral.vue?vue&type=script&lang=js"
export * from "./atualizacao-cadastral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports